export const AppConfig = {
  API_BASE_URL: process.env.VUE_APP_API_URL || 'http://localhost:5000/api',
  CONTACT_US_EMAIL: 'admin@thecolregs.com',
  SUPPORT_EMAIL: 'admin@thecolregs.com'
};